import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME } from '@modules/affiliates-approved/submodules/trackers-settings/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_MAIN_ROUTE_NAME,
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION,
} from './constants';
import {
  AffiliatesApprovedSubaffiliateConditionHistoryChangesEditModule,
} from './submodules/subaffiliate-history-changes-edit/SubaffiliateConditionHistoryChangesEditModule';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedTrackersSettingsSubaffiliateConditionModule extends AppModule {
  protected submodules: AppModule[] = [
    new AffiliatesApprovedSubaffiliateConditionHistoryChangesEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_MAIN_ROUTE_NAME,
      path: 'subaffiliate-condition',
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      redirect: { name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_ROUTE_NAME },
    });

    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_MAIN_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_ROUTE_NAME,
      path: '',
      component: () => import('./pages/TrackersSettingsSubaffiliateConditionPage/TrackersSettingsSubaffiliateConditionPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION, getTranslationKeys);
  }
}
